import { Box, Stack, Typography } from "@mui/material";
import { CreateButton, useListContext } from "react-admin";
import useAppBarHeight from "../misc/useAppBarHeight";

type ContactEmptyProps = {
  inline?: boolean;
  subtitle?: string;
  showActions?: boolean;
};

export const ContactEmpty = ({
  inline = false,
  subtitle,
  showActions,
}: ContactEmptyProps) => {
  const appbarHeight = useAppBarHeight();
  const { filterValues } = useListContext();
  const hasFilters = filterValues && Object.keys(filterValues).length > 0;
  const resolvedSubtitle =
    subtitle ??
    (hasFilters
      ? "Ajuste os filtros para encontrar análises."
      : "Sua lista de Análises está vazia.");
  const resolvedShowActions = showActions ?? !hasFilters;

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      gap={3}
      sx={
        inline
          ? { py: 6 }
          : { height: `calc(100dvh - ${appbarHeight}px)` }
      }
    >
      <Box
        component="img"
        src="./img/empty.svg"
        alt="Nenhuma análise encontrada"
        sx={inline ? { width: 220, maxWidth: "80%" } : undefined}
      />
      <Stack gap={0} alignItems="center">
        <Typography variant="h6" fontWeight="bold">
          Nenhuma Análise encontrada
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          gutterBottom
        >
          {resolvedSubtitle}
        </Typography>
      </Stack>
      {resolvedShowActions && (
        <Stack spacing={2} direction="row">
          <CreateButton variant="contained" label="Nova Análise" />
        </Stack>
      )}
    </Stack>
  );
};
